import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap"

import { Link, useNavigate } from "react-router-dom"
import CounterFundRequestModal from "./counterFundRequestModal"
import Spinners from "components/Common/Spinner"
import {
  formatAmount,
  formatTenure,
  getFundRequirementDate,
} from "helpers/common"
import moment from "moment"
import {
  useLazyGetFundRequestsQuery,
  useShowInterestMutation,
} from "store/api/investorapi/icds.api"
import toast from "react-hot-toast"
import NoDataFound from "components/Common/NoDataFound"
import LoaderComponent from "components/loader"
import Breadcrumb from "components/Common/Breadcrumb"
import SignAgreementModal from "../signAgreementModal"
import { usePermission } from "hooks/usePermission"
import ProgressBar from "@ramonak/react-progress-bar"

const defaultFilters = {
  search: "",
  page: 1,
  created_by: "ADMIN",
  pageSize: 20,
  timestamp: "",
}

const FundRequests = () => {
  document.title = "Fund Requests - Prachay"
  let navigate = useNavigate()
  const [getResults, { isFetching }] = useLazyGetFundRequestsQuery()
  const [showInterest, { isLoading }] = useShowInterestMutation()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  // const [count, setCount] = useState(0)
  const [open, setOpen] = useState(false)
  const [cancelRequestOpen, setCancelRequestOpen] = useState(false)
  const [selectedData, setSelectedData] = useState()
  const { hasPermission } = usePermission()

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data)
      // setData(data?.rows)
      // setCount(data?.count)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const onShowInterest = async (id) => {
    try {
      const updatedRows = data.map((item) =>
        item.id === id ? { ...item, isLoading: true } : item
      )
      setData(updatedRows)
      const { success, message } = await showInterest({ id }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        onSuccess()
      }
    } catch (error) {
      if (error.status === 409) {
        setCancelRequestOpen(true)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    } finally {
      const updatedRows = data.map((item) => ({ ...item, isLoading: false }))
      setData(updatedRows)
    }
  }

  const onSuccess = () => {
    setOpen(false)
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
    navigate("/icd-investments/my-icds")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <CardTitle className="mb-3 pt-4">Fund Requests</CardTitle> */}
          <Breadcrumb title={"Fund Requests"} />
          <Card>
            <CardBody>
              {isFetching && <LoaderComponent />}
              {!isFetching && data.length > 0 && (
                <>
                  <Row className="my-4 row-gap">
                    {data.map((item, index) => (
                      <Col key={`data_${index}`} xl={4}>
                        <div className="active-bonds-card-wrapper">
                          <div className="d-flex align-items-start justify-content-between">
                            <div className="card-title card-title2">
                              <h4>{item.unique_code}</h4>
                              <p>Admin</p>
                            </div>
                            {!item.already_shown_interest && (
                              <div className="bond-status">
                                <p className={item?.status.toLowerCase()}>
                                  <span></span>{" "}
                                  {item?.status.charAt(0).toUpperCase() +
                                    item?.status.slice(1).toLowerCase()}
                                </p>
                              </div>
                            )}
                          </div>

                          <div className="card-desc">
                            <div className="card-desc-inner">
                              <h5>Amount</h5>
                              <p>₹ {formatAmount(item.amount)}</p>
                            </div>
                            <div className="card-desc-inner">
                              <h5>Interest Rate</h5>
                              <p>{item.interest_rate}% p.a.</p>
                            </div>
                            <div className="card-desc-inner">
                              <h5>Fund Requirement</h5>
                              <p>
                                {getFundRequirementDate(
                                  item.fund_requirement_date
                                )}
                              </p>
                            </div>
                            <div className="card-desc-inner">
                              <h5>Maturity date</h5>
                              <p>
                                {moment(item.repayment_date).format(
                                  "DD MMM YYYY"
                                )}
                              </p>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <ProgressBar
                              borderRadius="8px"
                              height="8px"
                              baseBgColor="#9b9b9b33"
                              bgColor="#F0A735"
                              completed={
                                item.total_invested_amount > 0
                                  ? Math.max(
                                      (item.total_invested_amount /
                                        item.amount) *
                                        100,
                                      0.01
                                    )
                                  : 0
                              }
                              isLabelVisible={false}
                            />
                            <div className="amount-wrapper">
                              <div className="right-box">
                                <p>
                                  Req. Amount{" "}
                                  <span>
                                    ₹{" "}
                                    {formatAmount(
                                      item.amount - item.total_invested_amount
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                          {item.status === "OPEN" &&
                            !item.already_shown_interest && (
                              <>
                                <hr />
                                {hasPermission(
                                  "SHOW_INTEREST_FUND_REQUIREMENTS"
                                ) && (
                                  <Link
                                    to={"#"}
                                    onClick={() => {
                                      if (!item.isLoading)
                                        onShowInterest(item.id)
                                    }}
                                  >
                                    {item.isLoading ? (
                                      <Spinners />
                                    ) : (
                                      "Show Interest"
                                    )}
                                  </Link>
                                )}
                                {hasPermission("COUNTER_FUND_REQUIREMENTS") && (
                                  <Link
                                    className="counteroffer"
                                    to={"#"}
                                    onClick={() => {
                                      setSelectedData(item)
                                      setOpen(true)
                                    }}
                                  >
                                    Counter Offer
                                  </Link>
                                )}
                              </>
                            )}
                          {item.already_shown_interest && (
                            <Link
                              to={`/icd-investments/my-icds/view/${item.id}`}
                              style={{
                                marginTop: "10px",
                              }}
                            >
                              View
                            </Link>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
              {!isFetching && data.length <= 0 && (
                <NoDataFound description="There is currently no fund request to display." />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
      <CounterFundRequestModal
        open={open}
        setOpen={setOpen}
        data={selectedData}
        setCancelRequestOpen={setCancelRequestOpen}
        onSuccess={onSuccess}
      />

      <SignAgreementModal
        open={cancelRequestOpen}
        setOpen={setCancelRequestOpen}
        showAlert={true}
      />
    </React.Fragment>
  )
}

export default FundRequests
